import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

const Login = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [showPassword, setShowPassword] = useState(false);

    const [currentSlide, setCurrentSlide] = useState(0);

    const navigate = useNavigate();

    // Données des slides
    const slides = [
        {
            title: "Bienvenue sur votre tableau de bord de marketing des ventes",
            description: "Préparez-vous à transformer votre stratégie commerciale et marketing grâce à des outils performants et à des analyses basées sur l'IA. Découvrez les points essentiels !"
        },
        {
            title: "Analyses avancées et insights",
            description: "Obtenez des insights détaillés sur vos performances de vente et optimisez votre stratégie marketing avec des données précises et des recommandations personnalisées."
        },
        {
            title: "Gestion intelligente des stocks",
            description: "Gérez vos inventaires de manière intelligente avec des alertes automatiques et des prévisions basées sur l'historique des ventes et les tendances du marché."
        },
        {
            title: "Suivi des performances en temps réel",
            description: "Surveillez vos métriques de vente en temps réel et prenez des décisions éclairées pour maximiser vos revenus et améliorer votre ROI."
        }
    ];

    // Auto-rotation des slides
    useEffect(() => {
        const interval = setInterval(() => {
            setCurrentSlide((prev) => (prev + 1) % slides.length);
        }, 4000); // Change de slide toutes les 4 secondes

        return () => clearInterval(interval);
    }, [slides.length]);

    const handleSubmit = (e) => {
        e.preventDefault();
        // Logique de connexion à implémenter
        console.log('Tentative de connexion:', { email, password });
    };

    return (
        <div className="min-h-screen flex items-center justify-center p-4">
            {/* Background Image with Overlay */}
            <div className="absolute inset-0 bg-cover bg-center bg-no-repeat"
                style={{
                    backgroundImage: 'url("/images/auth/background-image.png")'
                }}>
            </div>

            <div className="relative z-10 flex w-full max-w-6xl justify-between">
                {/* Login Form - Left Side */}
                <div className="w-full lg:w-1/2 flex items-center justify-center">
                    <div className="bg-white rounded-3xl shadow-2xl p-10 w-full max-w-md">
                        <div className="flex justify-center">
                            <img src="/images/logo.png" alt="logo" className="w-auto h-14" />
                        </div>

                        {/* Welcome Message */}
                        <div className="text-center mb-8 mt-4">
                            <h2 className="text-xl font-bold text-gray-800 mb-2">
                                Bienvenue sur l'espace vendeur
                            </h2>
                            <p className="text-gray-600 text-sm">
                                Connectez-vous à votre tableau de bord et prenez en charge vos ventes dès aujourd'hui
                            </p>
                        </div>

                        {/* Login Form */}
                        <form onSubmit={handleSubmit} className="space-y-4">
                            {/* Email Field */}
                            <div>
                                <label htmlFor="email" className="block text-sm font-medium text-gray-700 mb-2">
                                    Adresse mail
                                </label>
                                <input
                                    type="email"
                                    id="email"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    placeholder="Adresse mail"
                                    className="text-sm w-full px-4 py-3 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200"
                                    required
                                />
                            </div>

                            {/* Password Field */}
                            <div>
                                <label htmlFor="password" className="block text-sm font-medium text-gray-700 mb-2">
                                    Mot de passe
                                </label>
                                <div className="relative">
                                    <input
                                        type={showPassword ? 'text' : 'password'}
                                        id="password"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        placeholder="Entrer votre mot de passe"
                                        className="text-sm w-full px-4 py-3 pr-12 border border-gray-300 rounded-full focus:outline-none focus:ring-2 focus:ring-orange-light focus:border-transparent transition-all duration-200"
                                        required
                                    />
                                    <button
                                        type="button"
                                        onClick={() => setShowPassword(!showPassword)}
                                        className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-gray-700"
                                    >
                                        {showPassword ? (
                                           <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-eye-off-icon lucide-eye-off"><path d="M10.733 5.076a10.744 10.744 0 0 1 11.205 6.575 1 1 0 0 1 0 .696 10.747 10.747 0 0 1-1.444 2.49"/><path d="M14.084 14.158a3 3 0 0 1-4.242-4.242"/><path d="M17.479 17.499a10.75 10.75 0 0 1-15.417-5.151 1 1 0 0 1 0-.696 10.75 10.75 0 0 1 4.446-5.143"/><path d="m2 2 20 20"/></svg>
                                        ) : (
                                            <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                                                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                                            </svg>
                                        )}
                                    </button>
                                </div>
                            </div>

                            {/* Forgot Password Link */}
                            <div className="text-right">
                                <Link
                                    to="/forgot-password"
                                    className="text-sm text-orange-light hover:text-orange-hover font-medium transition-colors"
                                >
                                    Mot de passe oublié ?
                                </Link>
                            </div>

                            {/* Login Button */}
                            <button onClick={() => navigate('/dashboard')}
                                type="submit"
                                className="w-full bg-orange-hover text-white text-base py-2 px-6 rounded-full hover:bg-orange-hover transform hover:scale-105 transition-all duration-200 shadow-lg"
                            >
                                Se connecter
                            </button>
                        </form>
                    </div>
                </div>

                {/* Marketing Message - Right Side */}
                <div className="hidden lg:flex lg:w-1/3 items-end justify-end">
                    <div className="text-white max-w-md text-center">
                        <h2 className="text-xl font-medium text-right mb-4">
                        {slides[currentSlide].title}
                        </h2>
                        <p className="text-sm text-gray-200 text-right leading-relaxed mb-2">
                        {slides[currentSlide].description}
                        </p>

                        <div className="flex justify-end space-x-1">
                        {slides.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentSlide(index)}
                                className={`w-2 h-2 rounded-full transition-all duration-300 ${
                                    index === currentSlide 
                                        ? 'bg-white scale-125' 
                                        : 'bg-gray-400 hover:bg-gray-300'
                                }`}
                            />
                        ))}
                        </div>
                    </div>
                </div>

             </div>
        </div>
    );
};

export default Login;
